/* eslint-disable */
/**
 * 使用方法：
 *
 * ```
 * <Tooltip
 *   cursor={
 *     <CustomLineCursor
 *       stroke="#abcdef"
 *       strokeDashArray="1 0"
 *     />
 *    }
 * />
 * ```
 */
export const CustomLineCursor = (props: any) => {
  const {
    stroke,
    strokeDashArray,
    height,
    points: [{ x }],
  } = props;
  if (x <= 0) return null;

  return (
    <svg className="stroke-2 md:stroke-[3]">
      <line
        x1={x}
        x2={x}
        y1={0}
        y2={height}
        stroke={stroke}
        strokeDasharray={strokeDashArray}
      />
    </svg>
  );
};
